<template>
<div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">

        <!-- SLIDE 1 -->
        <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Tema 3: La teoría de Piaget en el momento actual / pág. 1">
            <div class="container-fluid margen_principal">
                <div class="row" id="slide-1">
                    <div class="col-lg-12 col-md-12 col-12">
                        <div class="row mt-4">
                            <div class="col-lg-5 col-md-12">
                                <h2>3. La teoría de Piaget en el momento actual</h2>
                                <p class="mt-4">Según Meece (2000), “las teorías neo-piagetianas han intentado mejorar […] sin modificar las suposiciones fundamentales de la teoría” (p. 123). También menciona la autora que:</p>
                                <div class="citacion1 p-4 ml-md-5 ml-0">
                                    <p class="mb-0 pb-0">Las teorías de Piaget no escaparon a la crítica, algunos rechazan su teoría de las etapas invariables; otros señalan que no haya tenido en cuenta el contexto cultural donde se desarrollan las habilidades del pensamiento y otros piensan que su idea de equilibro es inadecuada (p. 121).</p>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-12 offset-lg-1 mt-lg-0 mt-4">
                                <p>Como lo indica Meece (2000), “A Piaget se le ha criticado principalmente por sus ideas concernientes a la naturaleza cualitativa del desarrollo cognoscitivo” (p. 121). Sin embargo, su teoría y aplicación se encuentran vigentes y son una gran herramienta para el análisis y conceptualización psicobiológica del desarrollo cognitivo del ser humano en las primeras etapas de su vida.</p>
                                <div class="row align-items-center">
                                    <div class="col-lg-6 col-md-12">
                                        <b-img src="recursos/img/DCSS0_014_Tema3_img1.png" class="d-flex mx-auto" fluid alt=""></b-img>
                                        <h6 class="text-center txtfiguras mt-3">Adaptada de Freepik (s. f.). </h6>
                                    </div>
                                    <div class="col-lg-6 col-md-12 mt-lg-0 mt-4">
                                        <h6 class="text-center">Haga clic en el reproductor para escuchar el audio.</h6>
                                        <audio controls="" controlslist="nodownload" class="d-flex mx-auto mt-3">
                                            <source src="recursos/audio/Audio_U1_DCSS_01.mp3" type="audio/mp3">
                                        </audio>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- SLIDE 1 -->
    </div>
</div>
</template>

<script>
import {
    SwiperController
} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Tema3',
    mounted() {
        SwiperController(),
            document.title = this.$route.meta.title
    }
};
</script>
